import{scenarioCatalogueViewTypes} from './../../constants';
const defaultScenarioCatalogueData = {
    scenarioCatalogue: [],
    pages: [],
    currentPage: 0
};


const viewReducers = (state = defaultScenarioCatalogueData, action) => {
    switch(action.type) {
        case scenarioCatalogueViewTypes().addScenarioData:
            return {
                scenarioCatalogue: action.scenarioCatalogue,
                currentPage: action.currentPage,
                pages: action.pages
            }
        default:
            return state
    }
}

export default viewReducers;
